var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-top":"30px"}},[_c('a',{attrs:{"href":_vm.QWLoginUrl}},[_c('div',{staticClass:"btn"},[_c('img',{attrs:{"src":require('@/assets/img/qwLogin/qwImg/login_white_middle.png'),"alt":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }